// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"FatArrow_wrapper__1lmf0","fatArrow":"FatArrow_fatArrow__2fz39"};